import { Sport } from "@sportactics/board-editing";
import { Team } from "@sportactics/player-management";
import useSWR from "swr";

import { getSWRKey, SwrStore } from "~utils";

import { useUser } from "../user";
import { useCustomPlayersFirestorePersistence } from "./custom-players-firestore-persistence";
import { useSelectedSport } from "./use-selected-sport";

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function useTeamsFirestoreSWR() {
  const key = useKey();
  const fetcher = useFetcher();

  return useSWR(key, fetcher, { suspense: true });
}

export function getTeamsFirestoreSWRKey(
  userId: string,
  sport: Sport,
): TeamsFirestoreSWRKey {
  return getSWRKey(SwrStore.FirestoreCustomPlayerTeams, userId, sport);
}

export type TeamsFirestoreSWRKey = readonly [SwrStore, string, Sport];

function useKey(): TeamsFirestoreSWRKey | null {
  const { user } = useUser();
  const sport = useSelectedSport();

  if (sport === undefined || !user.authenticated) return null;
  return getTeamsFirestoreSWRKey(user.id, sport);
}

function useFetcher(): (key: TeamsFirestoreSWRKey) => Promise<Team[]> {
  const { getTeamsWithSport } = useCustomPlayersFirestorePersistence();

  return ([, userId, sport]) => getTeamsWithSport(userId, sport);
}
